export function waitAtLeast<T>(timeout) : (result:T) => Promise<T> {
    const created = new Date().getTime();
    return (result) => new Promise<T>((resolve) => {
        const elapsed = new Date().getTime() - created;
        console.log('Elapsed time', elapsed );
        if(elapsed >= timeout) {
            resolve(result);
        } else {
            setTimeout(resolve,timeout - elapsed);
        }        
    });    
}

export function isNullOrEmpty(value: any) : boolean {
    return value == null || value === ''; 
}

export function isCollectionNullOrEmpty(value: Array<any> | null | undefined) : boolean {
    return value == null || value.length === 0;
}